// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MoreOptionsDropdown_dropdown__19k8q","socialButtons":"MoreOptionsDropdown_socialButtons__xYWvS","socialButton":"MoreOptionsDropdown_socialButton__urDJg"};